module.exports = __webpack_public_path__ + "fonts/DM_Sans-100-latin-ext2.0d3827b.woff2";